// extracted by mini-css-extract-plugin
export var resizer = "_f0-0";